export default __webpack_public_path__ + "static/media/solar-energy.85f868f7.png";